import {
  INVENTORY_SUMMARY_PAGE_REQUEST,
  INVENTORY_SUMMARY_SUMMARY_REQUEST,
  INVENTORY_SUMMARY_ON_CHANGE_OUTLET_IDS,
  INVENTORY_SUMMARY_ON_CHANGE_DATE,
  INVENTORY_SUMMARY_ON_CHANGE_KEYWORD,
  INVENTORY_SUMMARY_EXPORT_SUMMARY,
  INVENTORY_SUMMARY_ON_CHANGE_NAMESPACE,
  INVENTORY_SUMMARY_INGREDIENT_INVENTORY_SUMMARY_REQUEST
} from 'actions/inventory/summary/constants'
import * as actInvSummary from 'actions/inventory/summary'
import {put, call, takeLatest} from 'redux-saga/effects'
import * as act from 'actions'
import * as apiOutlets from 'api/outlets'
import * as apiProfile from 'api/profile'
import * as apiInvSummary from 'api/inventory/summary'
import * as actNotif from 'actions/notifications'
import * as apiGetFilteredDate from 'api/get-filtered-date'
import {initialize} from 'redux-form'
import moment from 'moment'
import * as actGetExportedFile from 'actions/get-exported-file'
import * as apiCurrentInventory from 'api/currentInventoryDropdown'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import {getSubscriptionStatus} from 'api/feature/getSubscriptionStatus'
import * as apiIngInvSummary from 'api/ingredientInventory'
import {subscriptionStatus} from 'actions/inventory/ingredientSubscription'
import {
  NAMESPACE_ITEMS,
  NAMESPACE_INGREDIENTS
} from 'actions/inventory/constants'
import * as mpInvSummary from 'mixpanel/inventory/summary'

function mapItemsToRowItems (items) {
  const rows = []
  items.forEach((item) => {
    if (item.has_item_variants) {
      // push parent
      rows.push({
        item_name: item.item_name,
        category: item.category,
        outlet: item.outlet,
        isParent: true,
        hasChildren: true
      })
      item.item_variants.forEach((itemVariant) => {
        rows.push({
          ...itemVariant,
          isParent: false
        })
      })
    } else {
      rows.push({
        ...item.item_variants[0],
        item_name: item.item_name,
        category: item.category,
        outlet: item.outlet,
        isParent: true,
        hasChildren: false
      })
    }
  })
  return rows
}

export function * summaryRequestFlow (request) {
  const {payload: {params, previousItems, previousRowItems}} = request

  yield put(act.showProgressBar())
  try {
    let resSummary = yield call(apiInvSummary.getSummary, params)
    let items = resSummary.data.results
    const newItems = previousItems.concat(items)
    const newRowItems = previousRowItems.concat(mapItemsToRowItems(items))

    yield put(actInvSummary.setItems(newItems))
    yield put(actInvSummary.setRowItems(newRowItems))
    yield put(actInvSummary.setCurrentPage(params.page))
    yield put(actInvSummary.setTotalPage(resSummary.data.total_pages))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * pageRequest () {
  // reset...
  yield put(actInvSummary.setItems([]))
  yield put(actInvSummary.setRowItems([]))
  yield put(actInvSummary.setIngredients([]))
  // will be set false by summary request saga
  yield put(showPageLoadingSpinner(true))
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiOutlets.outlets)
    yield put(actInvSummary.setOutlets(response.data))

    let resProfile = yield call(apiProfile.getProfile)

    let resGetFilteredDate = yield call(apiGetFilteredDate.getFilteredDate)
    const startDate = moment(resGetFilteredDate.data.start_date)
    const endDate = moment(resGetFilteredDate.data.end_date)

    let resCurrentInventoryDropdown = yield call(apiCurrentInventory.getCurrentInventoryDropdown)
    const currentInventoryDropdown = resCurrentInventoryDropdown.data.current_inventory_dropdown

    if (currentInventoryDropdown !== 'ingredients') {
      yield put(actInvSummary.summaryRequest({
        page: 1,
        start_date: resGetFilteredDate.data.start_date,
        end_date: resGetFilteredDate.data.end_date
      }, [], [], currentInventoryDropdown))
    } else {
      yield put(actInvSummary.ingInvSummaryRequest({
        page: 1,
        start_date: resGetFilteredDate.data.start_date,
        end_date: resGetFilteredDate.data.end_date
      }, [], currentInventoryDropdown))
    }

    yield put(initialize('search', {
      outletIds: resProfile.data.outlet_id,
      date: {startDate, endDate},
      namespace: currentInventoryDropdown
    }))
    mpInvSummary.inventorySummaryStart({
      outletIds: resProfile.data.outlet_id,
      startDate,
      endDate,
      namespace: currentInventoryDropdown
    })

    yield put(subscriptionStatus())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * onChangeOutletIdsFlow (request) {
  yield put(actInvSummary.setRowItems([]))
  yield put(actInvSummary.setIngredients([]))
  // will be set false by summary request saga
  yield put(showPageLoadingSpinner(true))
  const {payload: {outletIds, startDate, endDate, namespace}} = request

  yield put(act.showProgressBar())
  try {
    yield call(apiOutlets.patchLogin, {id: outletIds})
    yield put(initialize('search', {
      outletIds,
      date: {startDate, endDate},
      namespace: namespace
    }))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }

  if (namespace !== 'ingredients') {
    yield put(actInvSummary.summaryRequest({
      page: 1,
      start_date: moment(startDate).format('YYYY/MM/DD'),
      end_date: moment(endDate).format('YYYY/MM/DD')
    }, [], []))
  } else {
    yield put(actInvSummary.ingInvSummaryRequest({
      page: 1,
      start_date: moment(startDate).format('YYYY/MM/DD'),
      end_date: moment(endDate).format('YYYY/MM/DD')
    }, []))
  }
}

export function * onChangeDate (request) {
  yield put(actInvSummary.setRowItems([]))
  yield put(actInvSummary.setIngredients([]))
  // will be set false by summary request saga
  yield put(showPageLoadingSpinner(true))
  const {payload: {keyword, startDate, endDate, namespace}} = request

  if (namespace !== 'ingredients') {
    yield put(actInvSummary.summaryRequest({
      page: 1,
      start_date: moment(startDate).format('YYYY/MM/DD'),
      end_date: moment(endDate).format('YYYY/MM/DD'),
      keyword: keyword
    }, [], [], namespace))
  } else {
    yield put(actInvSummary.ingInvSummaryRequest({
      page: 1,
      start_date: moment(startDate).format('YYYY/MM/DD'),
      end_date: moment(endDate).format('YYYY/MM/DD'),
      keyword: keyword
    }, [], namespace))
  }
}

export function * onChangeKeyword (request) {
  yield put(actInvSummary.setRowItems([]))
  yield put(actInvSummary.setIngredients([]))
  // will be set false by summary request saga
  yield put(showPageLoadingSpinner(true))
  const {payload: {keyword, startDate, endDate, namespace}} = request

  if (namespace !== 'ingredients') {
    yield put(actInvSummary.summaryRequest({
      page: 1,
      start_date: moment(startDate).format('YYYY/MM/DD'),
      end_date: moment(endDate).format('YYYY/MM/DD'),
      keyword: keyword
    }, [], []))
  } else {
    yield put(actInvSummary.ingInvSummaryRequest({
      page: 1,
      start_date: moment(startDate).format('YYYY/MM/DD'),
      end_date: moment(endDate).format('YYYY/MM/DD'),
      keyword: keyword
    }, [], namespace))
  }
}

export function * onChangeNamespace (request) {
  yield put(actInvSummary.setRowItems([]))
  yield put(actInvSummary.setIngredients([]))
  yield put(showPageLoadingSpinner(true))
  const {payload: {namespace, params}} = request
  yield put(act.showProgressBar())
  try {
    yield call(apiCurrentInventory.putCurrentInventoryDropdown, {current_inventory_dropdown: namespace})
    yield call(getSubscriptionStatus, {feature_names: ['Ingredient Inventory']})
    yield call(apiCurrentInventory.getCurrentInventoryDropdown, {})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    if (namespace !== 'ingredients') {
      yield put(actInvSummary.summaryRequest(params, [], [], namespace))
    } else {
      yield put(actInvSummary.ingInvSummaryRequest(params, [], namespace))
    }
    yield put(act.hideProgressBar())
  }
}

export function * ingInvSummaryRequest (request) {
  const {payload: {params, previousIngredients}} = request
  yield put(act.showProgressBar())
  try {
    let resSummary = yield call(apiIngInvSummary.getSummary, params)
    let ingredients = resSummary.data.results
    const newIngredients = previousIngredients.concat(ingredients)

    yield put(actInvSummary.setIngredients(newIngredients))
    yield put(actInvSummary.setCurrentPage(params.page))
    yield put(actInvSummary.setTotalPage(resSummary.data.total_pages))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * exportSummary (request) {
  const {payload: {params: {namespace, ...restParams}, filename, outletId}} = request
  try {
    if (namespace === NAMESPACE_ITEMS) {
      yield call(apiInvSummary.getExportSummary, restParams)
    } else if (namespace === NAMESPACE_INGREDIENTS) {
      yield call(apiIngInvSummary.getExportSummary, restParams)
    }
    // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'Summary'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export default function * saga () {
  yield takeLatest(INVENTORY_SUMMARY_PAGE_REQUEST, pageRequest)
  yield takeLatest(INVENTORY_SUMMARY_SUMMARY_REQUEST, summaryRequestFlow)
  yield takeLatest(INVENTORY_SUMMARY_ON_CHANGE_OUTLET_IDS, onChangeOutletIdsFlow)
  yield takeLatest(INVENTORY_SUMMARY_ON_CHANGE_DATE, onChangeDate)
  yield takeLatest(INVENTORY_SUMMARY_ON_CHANGE_KEYWORD, onChangeKeyword)
  yield takeLatest(INVENTORY_SUMMARY_EXPORT_SUMMARY, exportSummary)
  yield takeLatest(INVENTORY_SUMMARY_ON_CHANGE_NAMESPACE, onChangeNamespace)
  yield takeLatest(INVENTORY_SUMMARY_INGREDIENT_INVENTORY_SUMMARY_REQUEST, ingInvSummaryRequest)
}



// WEBPACK FOOTER //
// ./app/sagas/inventory/summary.js